import './less/default.less'

import { StrictMode } from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import { StylesAsDataAttributes } from 'substyle-glamor'

import { ErrorBoundary, UI5Theme } from '@signavio/effektif-commons'

import Main from './containers'
import history from './history'
import store from './store'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

const SignavioWorkflowAccelerator = () => (
  <UI5Theme>
    <StylesAsDataAttributes>
      <Provider store={store}>
        <Router history={history}>
          <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
              {process.env.REACT_STRICT_MODE ? (
                <StrictMode>
                  <Main />
                </StrictMode>
              ) : (
                <Main />
              )}
            </QueryClientProvider>
          </ErrorBoundary>
        </Router>
      </Provider>
    </StylesAsDataAttributes>
  </UI5Theme>
)

export default SignavioWorkflowAccelerator
